<template>
  <div class="mobile-nav">
    <div id="logo-container">
      <img
        src="@/assets/logo.png"
        id="main-logo-image"
        @click="goToRoute('/')"
      />
      <span id="buy-rent-sell">
        <p class="title-descipion-text">buy.</p>
        <p class="title-descipion-text">rent.</p>
        <p class="title-descipion-text">sell.</p>
      </span>
    </div>
    <div class="menu" :class="{ open: isOpen }">
      <span
        class="nav-item-spacer"
        :class="{ currentNavItem: currentRoute == 'Home' }"
      >
        <router-link
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'Home' }"
          to="/"
          @click.native="closeMenu"
          >home</router-link
        >
      </span>

      <span
        class="nav-item-spacer"
        :class="{ currentNavItem: currentRoute == 'Blog' }"
      >
        <router-link
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'Blog' }"
          to="/blog"
          @click.native="closeMenu"
          >blog</router-link
        >
      </span>

      <span
        class="nav-item-spacer"
        :class="{ currentNavItem: currentRoute == 'Team' }"
      >
        <router-link
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'Team' }"
          to="/team"
          @click.native="closeMenu"
          >team</router-link
        >
      </span>
      <span
        class="nav-item-spacer"
        :class="{ currentNavItem: currentRoute == 'support' }"
      >
        <router-link
          class="nav-item"
          :class="{ currentNavItem: currentRoute == 'support' }"
          to="/support"
          @click.native="closeMenu"
          >support</router-link
        >
      </span>
    </div>
    <button class="hamburger" @click="toggleMenu">
      <i class="fas fa-bars"></i>
      <!-- Hamburger menu icon -->
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
    goToRoute(path) {
      if (this.$route.path !== path) this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.mobile-nav {
  width: 100%;
  height: 88px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background-color: #ffffff;
}
.nav-item {
  color: rgb(12, 192, 150) !important;
}
.nav-item:hover {
  color: rgb(0, 160, 125) !important;
}

.currentNavItem {
  color: rgb(0, 160, 125) !important;
}
.currentNavItem a {
  color: rgb(0, 160, 125) !important;
  border-bottom: 1px solid rgb(12, 192, 150);
}

.nav-item-spacer {
  margin-bottom: 10px;
}

#logo-container {
  margin: 15px 0 0 15px;
}

#buy-rent-sell {
  height: 50px;
  display: flex;
  margin-left: -11px;
}

.title-descipion-text {
  color: rgb(12, 192, 150);
  font-weight: bold;
  font-size: 20px;
  padding-left: 10px;
}

#main-logo-image {
  width: 245px;
  cursor: pointer;
}

.mobile-nav .menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 150px;
  height: 100vh;
  background: #fff;
  z-index: 9;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 6rem;
}

.hamburger {
  background: #fff;
  border: none;
  cursor: pointer;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  position: fixed;
  top: 10px;
  right: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.hamburger i {
  font-size: 20px;
  color: rgb(12, 192, 150);
}

.mobile-nav .menu.open {
  transform: translateX(0);
}

.mobile-nav .menu a {
  color: #333;
  font-size: 18px;
  margin-bottom: 10px;
  text-decoration: none;
}
</style>
